<template>
	<pui-datatable
		:modelName="modelName"
		:customizeActionAvailability="customizeActionAvailability"
		:parentModelName="parentModelName"
		:parentModel="parentModel"
		:externalFilter="externalFilter"
		:masterDetail="masterDetail"
		:readOnly="readOnly"
		:showMasterDetailFilterListBtn="true"
		:showMasterDetailFilterBtn="true"
		:showMasterDetailSortBtn="true"
		:showMasterDetailConfBtn="true"
	></pui-datatable>
</template>

<script>

import PuiGridDetailMixin from 'pui9-mixins/PuiGridDetailMixin';
import { STATUS_DRAFT_ID } from '../../constants/imofalforms/ImoFalFormsConstants';

export default {
	name: 'imofalform6vehicles-grid',
	mixins: [PuiGridDetailMixin],
	components: {},
	data() {
		return {
			modelName: 'imofalform6vehicles',
			modelColumnDefs: {
				indtransit: {
					render: (data) => {
						if (data == '1') {
							return this.$t('grid.imofalform6.transit');
						} else if (data == '0') {
							return this.$t('grid.imofalform6.nottransit');
						} else {
							return '';
						}
					}
				}
			}
		};
	},
	methods: {
		customizeActionAvailability(actionId, parentModel) {
			if (actionId === 'puiImportAction' || actionId === 'puiExportAction') {
				return parentModel.statusid === STATUS_DRAFT_ID;
			}
		}
	}
};
</script>
